import { render } from "./BaseTemplate.vue?vue&type=template&id=8700d08a&ts=true"
import script from "./BaseTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseTemplate.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/templates/BaseTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8700d08a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8700d08a', __exports__)) {
    api.reload('8700d08a', __exports__)
  }
  
  module.hot.accept("./BaseTemplate.vue?vue&type=template&id=8700d08a&ts=true", () => {
    api.rerender('8700d08a', render)
  })

}


export default __exports__